export enum SortOption {
  AcquisitionTime = 'AcquisitionTime',
  CashDue = 'CashDue',
  FreeShipping = 'FreeShipping',
  HighestPrice = 'HighestPrice',
  LowestMileage = 'LowestMileage',
  LowestPrice = 'LowestPrice',
  MonthlyPayment = 'MonthlyPayment',
  MostPopular = 'MostPopular',
  NewestInventory = 'NewestInventory',
  NewestYear = 'NewestYear'
}

export function isValidSortOption(value?: string): value is SortOption {
  return value != null && value in SortOption;
}

// Case-insensitive lookup for sort values typed by hand into a URL (e.g. a
// query param), as opposed to cvnaid-decoded values, which are always
// generated programmatically with exact casing and use isValidSortOption.
export function normalizeSortOption(value?: string): SortOption | undefined {
  if (value == null) return undefined;

  return Object.values(SortOption).find(
    option => option.toLowerCase() === value.toLowerCase()
  );
}

export default SortOption;
